import { useMaterialModel } from 'api';

import { useEvidenceAiSessionDetails } from '../../hooks/useEvidenceAiSessionDetails/useEvidenceAiSessionDetails';
import { EvidenceAiDetails } from '../EvidenceAiDetails/EvidenceAiDetails';

export const EvidenceAiSessionDetails = ({
  date,
  parentContentTypeId,
  parentId,
  uploadedById,
  siteMaterialId,
}: {
  date: string;
  parentContentTypeId: number;
  parentId: number;
  uploadedById: number | null;
  siteMaterialId: number;
}) => {
  const { averageFeatures, photoEvidence, stats, attachmentDetails, targetWeightPercentage } =
    useEvidenceAiSessionDetails({
      date,
      parentContentTypeId: parentContentTypeId,
      parentId: parentId,
      uploadedById: uploadedById,
    });
  const model = useMaterialModel(String(siteMaterialId ?? ''), false);

  return (
    <EvidenceAiDetails
      averageFeatures={averageFeatures}
      photoEvidence={photoEvidence}
      stats={stats}
      model={model ?? 'alu'}
      attachmentDetails={attachmentDetails}
      targetWeightPercentage={targetWeightPercentage}
    />
  );
};
